import React, { useState, useContext } from 'react';
import { View, Text, TextInput, StyleSheet, TouchableOpacity, KeyboardAvoidingView, Platform } from 'react-native';
import { AuthContext } from '../context/AuthContext';
import { showAlert } from '../services/confirm';
import Colors from '../constants/Colors';

const theme = Colors.light;
const { spacing, radius } = Colors;

export default function LoginScreen({ navigation }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const { login } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);

    const handleLogin = async () => {
        if (!username || !password) {
            showAlert('提示', '请输入用户名和密码');
            return;
        }
        setLoading(true);
        try {
            const result = await login(username, password);
            if (!result.success) showAlert('登录失败', result.error);
        } catch (e) {
            showAlert('错误', e.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <KeyboardAvoidingView
            style={styles.container}
            behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
        >
            <View style={styles.inner}>
                {/* Branding */}
                <View style={styles.brand}>
                    <Text style={styles.iconText}>❤️</Text>
                    <Text style={styles.appName}>情侣评分系统</Text>
                    <Text style={styles.tagline}>记录恋爱的点点滴滴</Text>
                </View>

                {/* Form – iOS grouped style */}
                <View style={styles.formGroup}>
                    <View style={styles.inputRow}>
                        <TextInput
                            style={styles.input}
                            placeholder="用户名"
                            placeholderTextColor={theme.textTertiary}
                            value={username}
                            onChangeText={setUsername}
                            autoCapitalize="none"
                            autoCorrect={false}
                        />
                    </View>
                    <View style={styles.divider} />
                    <View style={styles.inputRow}>
                        <TextInput
                            style={styles.input}
                            placeholder="密码"
                            placeholderTextColor={theme.textTertiary}
                            value={password}
                            onChangeText={setPassword}
                            secureTextEntry
                        />
                    </View>
                </View>

                {/* Login Button */}
                <TouchableOpacity
                    style={[styles.primaryBtn, loading && styles.primaryBtnDisabled]}
                    onPress={handleLogin}
                    disabled={loading}
                    activeOpacity={0.7}
                >
                    <Text style={styles.primaryBtnText}>{loading ? '登录中...' : '登录'}</Text>
                </TouchableOpacity>

                {/* Register Link */}
                <TouchableOpacity
                    style={styles.secondaryLink}
                    onPress={() => navigation.navigate('Register')}
                >
                    <Text style={styles.linkText}>没有账号？</Text>
                    <Text style={styles.linkAction}>立即注册</Text>
                </TouchableOpacity>
            </View>
        </KeyboardAvoidingView>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: theme.backgroundGrouped, // iOS grouped background color
    },
    inner: {
        flex: 1,
        justifyContent: 'center',
        paddingHorizontal: spacing.lg,
    },

    // Branding
    brand: {
        alignItems: 'center',
        marginBottom: spacing.xxxl,
    },
    iconText: {
        fontSize: 60,
        marginBottom: spacing.md,
    },
    appName: {
        fontSize: 34,
        fontWeight: '700',
        color: theme.text,
        letterSpacing: 0.4,
        marginBottom: spacing.xs,
    },
    tagline: {
        fontSize: 17,
        color: theme.textSecondary,
        letterSpacing: -0.4,
    },

    // Form – iOS grouped card
    formGroup: {
        backgroundColor: theme.backgroundSecondary,
        borderRadius: radius.lg,
        overflow: 'hidden',
        marginBottom: spacing.xl,
    },
    inputRow: {
        paddingHorizontal: spacing.lg,
        height: 50, // Standard iOS height
        justifyContent: 'center',
    },
    input: {
        fontSize: 17,
        color: theme.text,
        height: '100%',
    },
    divider: {
        height: StyleSheet.hairlineWidth,
        backgroundColor: theme.border,
        marginLeft: spacing.lg,
    },

    // Primary Button
    primaryBtn: {
        backgroundColor: theme.blue, // System Blue
        borderRadius: radius.lg,
        paddingVertical: 14,
        alignItems: 'center',
        marginBottom: spacing.lg,
    },
    primaryBtnDisabled: {
        opacity: 0.5,
    },
    primaryBtnText: {
        color: '#fff',
        fontSize: 17,
        fontWeight: '600',
    },

    // Secondary Link
    secondaryLink: {
        flexDirection: 'row',
        justifyContent: 'center',
        gap: spacing.xs,
        paddingVertical: spacing.md,
    },
    linkText: {
        fontSize: 15,
        color: theme.textSecondary,
    },
    linkAction: {
        fontSize: 15,
        color: theme.blue,
        fontWeight: '600',
    },
});
